import React from 'react'
import SVG from 'react-svg-inline'
import ReactPlayer from 'react-player'
import ImageZoom from 'react-medium-image-zoom'


const SketchRunner = () =>
  <div>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          This acclaimed Sketch plugin was born during the Sketch Hack Day in Hamburg and some members of the team decided to keep it alive ;) one year after and with more than 40K downloads Sketch Runner has positioned as an essential tool for many designers around world.
        </blockquote>
      </div>
    </section>
    <section className="container">
    <div className="fullwidth-video-wrapper">
      {/* <video src="https://www.youtube.com/watch?v=-1sX-giVzeE" loop muted autoPlay className="fullwidth-video" /> */}
      <ReactPlayer
        url="https://www.youtube.com/watch?v=-1sX-giVzeE?vq=hd1080"
        className="video-player"
        width="100%"
        height="90%"
        playing={true}
        playbackRate={1.2}
        loop={true}
        // youtubeConfig={{ attributes: { preload: true } }}
        // TODO Add custom posters for videos (to be also used as fallback images) 👇 This is supposed to work: https://github.com/CookPete/react-player/issues/62
        fileConfig={{ attributes: { poster: 'https://placehold.it/100x100/' } }}
      />
    </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          Runner helps you to get around Sketch quicker by giving you an intuitive interface to supercharge your daily workflow. Stop searching actions through your menu & start running commands directly from your keyboard.
        </blockquote>
      </div>
    </section>

    {/* <section className="container full">
      <div className="col-12-of-12">
        <img src={require('img/sketchrunner/laptop-2.jpg')} alt="Runner" />
      </div>
    </section> */}

    <section className="container">
      <div className="col-12-of-12">
        <ImageZoom
          image={{
            src: require('img/sketchrunner/themes.jpg'),
            alt: 'Runner',
          }}
        />
      </div>
      <div className="col-12-of-12">
        <ImageZoom
          image={{
            src: require('img/sketchrunner/userflows.jpg'),
            alt: 'Runner',
          }}
        />
      </div>
      <div className="col-12-of-12">
        <ImageZoom
                  image={{
                    src: require('img/sketchrunner/install.jpg'),
                    alt: 'Runner',
                  }}
                />      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          If you’ve used Spotlight for Mac you alredy know how Runner works. It basically enables the user to trigger certain actions just by using the keyboard, hence removing the need to use the mouse to clickity-click around the interface. Go get it at sketchrunner.com
        </blockquote>
      </div>
    </section>
    {/* <section className="container full split-view m-tb-m">
      <aside className="content">

      </aside>
      <aside>
        <img src={require('img/sketchrunner/themes.jpg')} alt="JOMO Feature" />
      </aside>
    </section>
    <section className="container full split-view m-tb-m">
      <aside>
        <img src={require('img/sketchrunner/userflows.jpg')} alt="JOMO Feature" />
      </aside>
      <aside className="content">

      </aside>
    </section>
    <section className="container full split-view m-tb-m">
      <aside className="content">

      </aside>
      <aside>
        <img src={require('img/sketchrunner/install.jpg')} alt="JOMO Feature" />
      </aside>
    </section> */}
    {/* <section className="container full">
      <div className="col-12-of-12">
        <SVG svg={Illustrations} width="100%" />
      </div>
    </section> */}
    <section className="container">
    <div className="macbook">
      <a target="_blank" href="https://medium.com/sketch-app-sources/1-year-of-sketch-runner-b4dd822d5e4d">
    		<div className="css-mb with-glare">
    		  <div className="mb-display-position">
    		    <div className="mb-display">
    		      <div className="mb-screen-position">
    		        <div className="mb-screen">
    		          <img src={require('img/sketchrunner/medium-screenshot.png')} alt="example" />
    		        </div>
    		      </div>
    		    </div>
    		  </div>
    		  <div className="mb-body"></div>
    		  <div className="mb-bottom-cover"></div>
    		</div>
      </a>
    		<p>Read the recap of the first year of Runner written by Roy in this <a target="_blank" href="https://medium.com/sketch-app-sources/1-year-of-sketch-runner-b4dd822d5e4d">Medium post ▸</a></p>
    		</div>
    </section>
    <section className="container full">
      <div className="col-12-of-12">
        <a href="http://sketchrunner.com">
        <img src={require('img/sketchrunner/footer.jpg')} alt="footer" />
        </a>
      </div>
    </section>
  </div>

export default SketchRunner



// WEBPACK FOOTER //
// src/javascripts/clients/SketchRunner.js